// Autogenerated file
export const bidTypesEnum = {
    Private: "Private",
    Public: "Public",
};
export const bidTypes = [
    { label: "Внутренняя", value: "Private" },
    { label: "Внешняя", value: "Public" },
];
